export default "__VITE_ASSET__BZwa7w6Y__"